module.exports = __webpack_public_path__ + "img/1920_app_download_qr.90c35af0.svg";